import { Injectable } from '@angular/core';
import { OperationDetails } from '@modules/operations/Domain/operation.model';

@Injectable({
  providedIn: 'root',
})
export class OperationConceptService {
  canAddConcept(operation: OperationDetails, newAmount: number): boolean {
    const currentTotal = operation.items.reduce((sum, item) => sum + item.amount, 0);
    const futureTotal = currentTotal + newAmount;

    return futureTotal > 0;
  }
}
